
export default class ForgotPasswordRequest {

    static toJson(username) {

        let jsonObj = {};

        jsonObj["username"] = username;

        return jsonObj;

    }

}